import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { LinkedService } from './linkedservice';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { format } from '../../shared/utils/string.util';
import { Credential } from '../credential/credential';

export const azureSynapseArtifactsAuthTypes = {
    MSIAuthentication: 'MSI',
    UserAssignedManagedIdentity: 'UAMI'
};

@Metamodel.model({
    name: 'AzureSynapseArtifacts',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureSynapseAnalyticsArtifacts),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureSynapseAnalyticsArtifacts)
    ]
})
export class AzureSynapseArtifactsLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly ENDPOINT: IAttribute;
    public static readonly WORKSPACE_RESOURCE_ID: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Authentication
    })
    public authenticationMethod?: string = azureSynapseArtifactsAuthTypes.MSIAuthentication;

    @Metamodel.attribute({
        display: stringResources.Credential,
        reference: true
    })
    public credential?: Credential;

    @Metamodel.attribute({
        display: stringResources.ModelName_SynapseWorkspaceEndpoint,
        association: 'ENDPOINT',
        templatable: true
    })
    public endpoint: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_WorkspaceResourceId,
        association: 'WORKSPACE_RESOURCE_ID',
        templatable: true
    })
    public workspaceResourceId?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
